import React from 'react';
import { Link } from 'react-router-dom'; // Ensure Link is imported
import { PinIcon, UnPinIcon } from '../../assets/icons/PinIcon'; // Import the pin and unpin icons

const CaseBox = ({ caseData, onToggleTag }) => {
  const { shipment_id, thread_id, case_number, subject, issue, status, is_pinned, emailBodies} = caseData;
  const earliestEmail = emailBodies.reduce((earliest, email) => {
    const currentTimestamp = new Date(email.timestamp);
    const earliestTimestamp = new Date(earliest.timestamp);
    return currentTimestamp < earliestTimestamp ? email : earliest;
  });

  // Step 2: Format the earliest timestamp to "date-month-year"
  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
  };

  const date = formatDate(earliestEmail.timestamp);
  return (
    <Link to={`cases/${shipment_id}`} className="block">
      <div
        className={`flex border pt-5 border-black items-center bg-white p-4 shadow-md rounded-lg mb-4 relative hover:shadow-lg ${
          issue === true ? "border-l-[6px] border-l-logo" : ""
        }`}
      >
        {/* Pin/UnPin Icon */}
        <button
          className={`p-1 pl-0 rounded-full ${
            is_pinned ? "text-logo" : "text-font-LIGHT"
          }`}
          onClick={(e) => {
            e.preventDefault(); // Prevent navigation
            e.stopPropagation(); // Prevent Link navigation
            onToggleTag(case_number, is_pinned); // Toggle tag functionality
          }}
        >
          {is_pinned ? (
            <PinIcon className="w-6 h-6" />
          ) : (
            <UnPinIcon className="w-6 h-6" />
          )}
        </button>
        <div className='flex justify-between w-full'>
            {/* Case Number */}
          <div className="text-base w-1/8 font-medium px-8 text-font-LIGHT">
            <span className="font-light">Case Number</span>
            <p className="font-bold text-font pt-1 pb-2">#{case_number}</p>
          </div>

          {/* Description */}
          <div className="text-base w-1/4 text-font-LIGHT flex-grow px-8">
            <span className="font-light">Description</span>
            <p className="font-bold text-font pt-1 pb-2">{subject}</p>
          </div>

          {/* Status */}
          <div className="text-base w-1/4 px-4 pl-1 text-font-LIGHT flex-grow">
            <span className="font-light">Status</span>
            <p
              className={`font-bold text-font pt-1 pb-2 text-font`}
            >
             {
                issue === true
                  ? "User input is required" // Message for when issue is true
                  : status === "pending"
                  ? "Waiting on carrier responses" // Message for pending status
                  : status === "completed"
                  // ? delivered
                  //   ? "Custom clearance completed & item delivered" // Message for completed and delivered
                  //   : "Custom clearance completed & out for delivery" // Message for completed and not delivered
                  // : status === "all"
                  ? "Displaying all cases" // Message for all status
                  : status === "initiated"
                  ? "Case initiated" // Message for initiated status
                  : status === "closed"
                  ? "Case closed" // Message for closed status
                  : ""
              }
            </p>
          </div>

          {/* Issue Date */}
          <div className="text-base pl-10 w-1/8 text-font-LIGHT flex-grow">
            <span className="font-light">Case Initiated</span>
            <p className="font-bold text-font pt-1 pb-2">{date}</p>
          </div>
        </div>
        
      </div>
    </Link>
  );
};

export default CaseBox;
